function onChange( value, err ) {
  if ( err ) {
    console.log( `error setting value to ${value}` );
    return;
  }
  this.props.onChange( { attribute : this.props.attribute, value } );
}

module.exports = {
  onChange
}
